let notificationsBridgeContext;
export const setApplicationNotificationsBridgeContext = context => {
    notificationsBridgeContext = context;
};
export const getApplicationNotificationsBridgeContext = () => notificationsBridgeContext;
//# sourceMappingURL=bridge.js.map